import React from "react";
import { Button } from "@material-ui/core";

const Submit = ({ isSubmitting, title }) => {
  return (
    <Button
      color="primary"
      disabled={isSubmitting}
      fullWidth
      size="large"
      type="submit"
      variant="contained"
    >
      {title}
    </Button>
  );
};

export default Submit;
